import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import Overlay from "../../../SharedComponents/Overlay";
import { getPositionById } from "../Store/Thunk";
import { ParseDate } from "../../../../Helpers/DateHelper";
import UpsertPositionModal from "../../CreatePosition/Components/UpsertPositionModal";
import {
  ChangeIsUpdateOperation,
  ShowUpsertPositionModal,
  UpdateUpsertPositionModalData,
} from "../../CreatePosition/Store";
import Button from "react-bootstrap/Button";
import { deletePosition } from "../../CreatePosition/Store/Thunk";
import AdminBreadCrumb from "../../AdminBreadCrumb";
import IconSvg from "../../../SharedComponents/IconSvg";
import ConfirmationModal from "../../../SharedComponents/GeneralModals";
import PositionCandidatesList from "./PositionCandidatesList";

export default function Position() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.position.isLoading);
  const position = useSelector((state) => state.position);
  const positionList = useSelector((state) => state.createPosition.positionList);
  const { state } = useLocation();
  const positionId = state?.positionId;

  const [positionToDelete, setPositionToDelete] = useState(null);
  const [confirmationModalIsShown, setConfirmationModalIsShown] = useState(false);

  useEffect(() => {
    dispatch(getPositionById({ id: positionId }));
  }, [positionList]);

  const HandleUpdateClick = (position) => {
    dispatch(UpdateUpsertPositionModalData(position));
    dispatch(ChangeIsUpdateOperation({ isUpdateOperation: true }));
    dispatch(ShowUpsertPositionModal({ upsertPositionModalIsShown: true }));
  };

  const DeletePosition = (id) => {
    setPositionToDelete({ id: id });
    setConfirmationModalIsShown(true);
  };

  const ConfirmationFunction = () => {
    dispatch(deletePosition(positionToDelete));
    navigate("/createPosition");
  };

  return (
    <div>
      {isLoading && <Overlay />}

      <ConfirmationModal
        isShown={confirmationModalIsShown}
        setIsShown={setConfirmationModalIsShown}
        confirmationFunction={ConfirmationFunction}
      />

      <Row className="mx-0 mb-2">
        <Col xs={{ order: 1, span: "auto" }} md={{ order: 0 }}>
          <AdminBreadCrumb
            pageName={t("createPositionBreadCrumbLabel")}
            backPageName={t("positionBreadCrumbLabel")}
            backUrl="/createPosition"
          />
        </Col>

        <Col className="mb-3" xs={{ order: 0, span: 12 }} md={{ order: 1, span: true }}>
          <Card className="breadcrumb-card h-100 p-md-0 p-2">
            <Row className="h-100 mx-0 justify-content-between">
              <Col className="align-content-center">
                <div className="text-20 text-color-gray-dark fw-medium">
                  {position?.name} {t("positionDetailTitleSuffix")}
                </div>
                {(position?.jobLevelName || position?.jobGroupName || position?.departmentName) && (
                  <div className="text-12 text-color-gray-light">
                    {position?.jobLevelName && <span>{position.jobLevelName}</span>}
                    {position?.jobLevelName && position?.jobGroupName && <span> • </span>}
                    {position?.jobGroupName && <span>{position.jobGroupName}</span>}
                    {(position?.jobLevelName || position?.jobGroupName) && position?.departmentName && <span> • </span>}
                    {position?.departmentName && <span>{position.departmentName}</span>}
                  </div>
                )}
              </Col>
              <Col className="text-14 text-end align-self-center text-color-gray-light">
                {t("createdByLabel")} {position?.createdBy} - {ParseDate(position.createdAt).date}{" "}
                {ParseDate(position.createdAt).time}
              </Col>
            </Row>
          </Card>
        </Col>

        <Col xs={{ order: 3, span: "auto" }} md={{ order: 2 }} className="ms-auto">
          <Button
            className="button secondary danger"
            size="sm"
            style={{ height: "46px", width: "46px", padding: "4px", borderRadius: "10px", borderWidth: "1px" }}
            onClick={() => DeletePosition(position.id)}
          >
            <IconSvg icon="delete" fill="currentColor" />
          </Button>
        </Col>

        <Col xs={{ order: 4, span: "auto" }} md={{ order: 3 }}>
          <Button
            className="button secondary"
            size="sm"
            style={{ height: "46px", width: "46px", padding: "4px", borderRadius: "10px", borderWidth: "1px" }}
            onClick={() => HandleUpdateClick(position)}
          >
            <IconSvg icon="edit" fill="currentColor" />
          </Button>
        </Col>
      </Row>

      {Boolean(position.description) && (
        <Row className="mx-0">
          <Col>
            <div className="text-20 text-color-gray-dark mb-3">{position.description}</div>
          </Col>
        </Row>
      )}

      <Row className="mx-0">
        <Col>
          <Card className="default-list with-shadow">
            <PositionCandidatesList candidatesList={position?.candidates} />
          </Card>
        </Col>
      </Row>

      <UpsertPositionModal />
    </div>
  );
}
